// Белая обводка вокруг рисунка (вырез outline, docs/SPEC_2026-10-22_GINGERBREAD_OUTLINE.md): пределы, умолчания и
// подписи. Общий модуль студии пряников и мастера «Создать пряники» — без React, чтобы его брала и чистая логика мастера.
import { formatNumber } from '../gingerbread-generator/shapeMetrics'
import type { FreeCutMode, OutlineSettings, OutlineSmooth } from './types'

export const OUTLINE_MIN_MM = 1
export const OUTLINE_MAX_MM = 8
export const OUTLINE_STEP_MM = 0.5
export const DEFAULT_OUTLINE: OutlineSettings = { widthMm: 3, smooth: 'medium' }

const SMOOTHS: OutlineSmooth[] = ['low', 'medium', 'high']

export const OUTLINE_SMOOTH_LABEL: Record<OutlineSmooth, string> = {
  low: 'Слабое', medium: 'Среднее', high: 'Сильное',
}

/** Подсказка под переключателем: обводка печатается белым и съедает часть предела 80 мм. */
export const OUTLINE_HINT = 'Обводка печатается белым и входит в 80 мм — рисунок станет меньше'
/** Подбор толщины не нашёл технологичной формы ни при какой ширине. */
export const OUTLINE_SUGGEST_FAILED = 'Подобрать не удалось — увеличьте сглаживание'

/** «3 мм», «2,5 мм» — ширина обводки с десятичной запятой. */
export const formatOutlineWidth = (widthMm: number): string => `${formatNumber(widthMm, 1)} мм`

/** Ширина в пределах 1–8 мм и кратна 0,5. */
export const clampOutlineWidth = (value: number): number => {
  if (!Number.isFinite(value)) return DEFAULT_OUTLINE.widthMm
  const stepped = Math.round(value / OUTLINE_STEP_MM) * OUTLINE_STEP_MM
  return Math.min(OUTLINE_MAX_MM, Math.max(OUTLINE_MIN_MM, stepped))
}

/** Обводка из ответа API: null, если поля нет или оно битое. */
export function toOutline(raw: unknown): OutlineSettings | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null
  const value = raw as Record<string, unknown>
  const width = Number(value.widthMm)
  if (value.widthMm == null || !Number.isFinite(width) || width <= 0) return null
  const smooth = SMOOTHS.find((candidate) => candidate === value.smooth) ?? DEFAULT_OUTLINE.smooth
  return { widthMm: width, smooth }
}

/** Значение переключателя выреза у свободной фигуры: всё, кроме outline, показывается как «Мой PNG как есть». */
export const freeCutModeOf = (cutMode: string | null | undefined): FreeCutMode => (cutMode === 'outline' ? 'outline' : 'exact')

export const sameOutline = (a: OutlineSettings | null | undefined, b: OutlineSettings | null | undefined): boolean =>
  Boolean(a && b && a.widthMm === b.widthMm && a.smooth === b.smooth)
